module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="b-tour-components">\n    <div class="banner-close" data-banner="В тур обычно входит_закрыть" data-index="'+
((__t=(hotelIndex))==null?'':__t)+
'">\n        <i class="icon icon-i16_close"></i>\n    </div>\n    ' + require("./search__tour-usually-includes-body.phtml").apply(null,arguments) + '\n</div>';
}
return __p;
};
